import React, { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast, SmartTooltip, StatusTags, TableAdv } from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobLeadsStart, fetchJobLeadsSuccess } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { formatWords2 } from "../../../../utils/stringUtils";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  fetchAllBDMUsers,
  fetchAllLeadJobs,
  updateLeadJob,
  userRefCount,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const Leads = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.bdmJobs.jobLeads);
    const { value } = useSelector((state) => state.totalCount);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const [allBdms, setAllBdms] = useState([]);
    const [selectedRows,setSelectedRows]=useState([])
    const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => { }
    );
    const totalCount = value?.leadJobCount?.data || 0;

    const getDaysOld = (dateString) => {
        const today = new Date();
        const postedDate = new Date(dateString);

    const diffTime = today - postedDate;
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  };
    const AgreementType={
        1: "Had a closure",
        2: "Agreement Signed",
    }
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const timeAgo = (dateString) => {
    if (!dateString) return "-";

    const now = new Date();
    const past = new Date(dateString);
    const seconds = Math.floor((now - past) / 1000);

    if (seconds < 60) return "Just now";

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hr${hours > 1 ? "s" : ""} ago`;

        const days = Math.floor(hours / 24);
        return `${days} day${days > 1 ? "s" : ""} ago`;
    };

    const handleViewLead = (companyId) => {
        if (!companyId) {
            showToast("Company Id not found!", "error");
            return;
        };

        sessionStorage.setItem(
            "leadCompanyUiid",
            companyId
        );

        navigate("/ats/bdm/priority-leads-view");
    };
    // const handleFollowupChange = (uiid, newDate, currentDate) => {
    //     if (!newDate) return;

    //     const newTime = new Date(newDate).getTime();
    //     const oldTime = currentDate ? new Date(currentDate).getTime() : null;

    //     if (newTime === oldTime) return;

    //     handleUpdateLeadJob(uiid, {
    //         followupScheduled: newDate,
    //     });
    // };
    const handleFollowupChange = (uiid, newDate, currentDate) => {
        if (!uiid) return;

        if (!newDate && currentDate) {
            handleUpdateLeadJob(uiid, {
                followupScheduled: null,
            });
            return;
        }
        const newTime = new Date(newDate).setHours(0, 0, 0, 0);
        const oldTime = currentDate
            ? new Date(currentDate).setHours(0, 0, 0, 0)
            : null;
        if (newTime === oldTime) return;

        handleUpdateLeadJob(uiid, {
            followupScheduled: newDate,
        });
    };

    const columns = [
        {
            key: "leadDate",
            label: "Lead Date",
            width: "min-w-[200px]! max-w-[250px]!",
            render: (row) => (
            <SmartTooltip
            description={formatDateTime(row?.leadDate)}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1 text-sm">{formatDateTime(row?.leadDate)}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "jobTitle",
            label: "Job Title",
            width: "min-w-[250px]! max-w-[300px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.jobTitle}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.jobTitle}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "postedDuration",
            label: "Posted On",
            width: "min-w-[200px]! max-w-[250px]!",
            getRowClass: (row) => {
                const daysOld = getDaysOld(row.postedon);
                if (daysOld >= 5) {
                    return "bg-primary-50";
                }
                return "";
            },
        },
        {
            key: "companyName",
            label: "Company Name",
            width: "min-w-[200px]! max-w-[250px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.companyName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.companyName}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "companyType",
            label: "Company Type",
            width: "min-w-[200px]! max-w-[250px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.companyType}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.companyType}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "status",
            label: "Status",
            render: (row) => {
                return (
                    <div className="w-[180px] min-w-[160px]">
                        <FormFieldSet
                            type="select"
                            noTitle
                            size="sm"
                            options={[
                                { label: "Active", value: 1 },
                                { label: "Followup", value: 2 },
                                { label: "Declined", value: 3 },
                                { label: "Positive Response", value: 4 },
                                { label: "Hold by Client", value: 5 },
                                { label: "On Hold", value: 6 },
                                { label: "Interview L1", value: 7 },
                                { label: "Interview L2", value: 8 },
                                { label: "Interview L3", value: 9 },
                                { label: "Priority", value: 10 },
                                { label: "Filled", value: 11 },
                                { label: "Closed", value: 12 },
                                { label: "Agreement Sent", value: 13 },
                                { label: "Agreement Accepted", value: 14 },
                            ]}
                            value={row?.status}
                            showSearch
                            onChange={(val) =>
                                handleUpdateLeadJob(row?.uiid, { status: val })
                            }
                        />
                    </div>
                );
            },
        },
        {
            key: "followSchedule",
            label: "Follow-up Schedule",
            render: (row) => (
                <div className="w-[180px] min-w-[160px]">
                    <FormFieldSet
                        type="datepicker"
                        noTitle
                        shadow={true}
                        minDate={yesterday}
                        placeholder="No Schedule"
                        value={
                            row?.followSchedule
                                ? new Date(row.followSchedule)
                                : null
                        }
                        // onChange={(date) =>
                        //     handleUpdateLeadJob(row?.uiid, {
                        //         followupScheduled: date,
                        //     })
                        // }
                        onChange={(date) =>
                            handleFollowupChange(
                            row?.uiid,
                            date,
                            row?.followSchedule
                            )
                        }
                        size="sm"
                    />
                </div>
            ),
        },
        {
            key: "jobLocation",
            label: "Job Location",
            width: "min-w-[200px]! max-w-[250px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.jobLocation}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.jobLocation}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "jobUrl",
            label: "Job URL",
            render: (row) => (
                <div className="flex-1 cursor-pointer flex items-center gap-2">
                    <a
                        target="_blank"
                        className="text-info underline"
                        rel="noreferrer"
                        href={row?.jobUrl}
                    >
                        Click
                    </a>
                </div>
            ),
        },
        {
            key: "rate",
            label: "Job Rate",
            width: "min-w-[200px]! max-w-[250px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.rate}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.rate}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "noOfApplicants",
            label: "No of Applicants Applied",
            width: "min-w-[200px]! max-w-[250px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.noOfApplicants}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.noOfApplicants}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "assignedTo",
            label: "Assigned To",
            render: (row) => {
                return (
                    <div className="w-[180px] min-w-[160px]">
                        <FormFieldSet
                            // type="onlyBDMUsers"
                            type="select"
                            options={allBdms}
                            noTitle
                            size="sm"
                            value={row?.assignedTo}
                            showSearch
                            onChange={(val) =>
                            {
                                handleUpdateLeadJob(row?.uiid, {
                                assignedTo: val || null,
                            })
                            // console.log("Selected BDM:", val);
                            }
                            }
                        />
                    </div>
                );
            },
        },
        {
            key: "",
            label: "Action",
            render: (row) => (
                <SmartTooltip description={"View"} noicon tooltipPosition="bottom">
                    <Button
                        type="icon"
                        color="black"
                        icon={"visibility"}
                        onClick={() => handleViewLead(row?.companyId)}
                        variant="text"
                        size="sm"
                    />
                </SmartTooltip>
            )

        },
    ];
    // const rows = [
    //     {
    //         id: 3,
    //         leadDate: "2026-01-27T09:00:00.000Z",
    //         jobTitle: "UI/UX Designer",
    //         postedon: "2026-02-02T11:00:00.000Z", // 3 days old
    //         companyName: "DesignHub",
    //         companyType: "Agency",
    //         status: 2,
    //         followSchedule: "No Schedule",
    //         jobLocation: "Mumbai",
    //         jobUrl: "https://designhub.com/jobs/3",
    //         rate: "$35/hr",
    //         noOfApplicants: 15,
    //         assignedTo: 3,
    //     },
    //     {
    //         id: 1,
    //         leadDate: "2026-01-29T09:00:00.000Z",
    //         jobTitle: "Frontend Developer",
    //         postedon: "2026-02-01T10:30:00.000Z", // 5 days old
    //         companyName: "TechNova",
    //         companyType: "Startup",
    //         status: 1,
    //         followSchedule: "No Schedule",
    //         jobLocation: "Bangalore",
    //         jobUrl: "https://technova.com/jobs/1",
    //         rate: "$40/hr",
    //         noOfApplicants: 12,
    //         assignedTo: 1,
    //     },
    //     {
    //         id: 2,
    //         leadDate: "2026-01-28T09:00:00.000Z",
    //         jobTitle: "Backend Developer",
    //         postedon: "2026-01-22T08:15:00.000Z", // 7 days old
    //         companyName: "InnoSoft",
    //         companyType: "Product",
    //         status: 3,
    //         followSchedule: "No Schedule",
    //         jobLocation: "Hyderabad",
    //         jobUrl: "https://innosoft.com/jobs/2",
    //         rate: "$45/hr",
    //         noOfApplicants: 8,
    //         assignedTo: 2,
    //     },
    //     {
    //         id: 4,
    //         leadDate: "2026-01-26T09:00:00.000Z",
    //         jobTitle: "QA Engineer",
    //         postedon: "2026-01-18T14:20:00.000Z", // 11 days old
    //         companyName: "QualityWorks",
    //         companyType: "Service",
    //         status: 4,
    //         followSchedule: "No Schedule",
    //         jobLocation: "Pune",
    //         jobUrl: "https://qualityworks.com/jobs/4",
    //         rate: "$30/hr",
    //         noOfApplicants: 6,
    //         assignedTo: 1,
    //     },
    //     {
    //         id: 5,
    //         leadDate: "2026-01-25T09:00:00.000Z",
    //         jobTitle: "DevOps Engineer",
    //         postedon: "2026-01-15T16:45:00.000Z", // 14 days old
    //         companyName: "CloudNet",
    //         companyType: "Enterprise",
    //         status: 9,
    //         followSchedule: "No Schedule",
    //         jobLocation: "Chennai",
    //         jobUrl: "https://cloudnet.com/jobs/5",
    //         rate: "$50/hr",
    //         noOfApplicants: 10,
    //         assignedTo: 2,
    //     },
    //     {
    //         id: 6,
    //         leadDate: "2026-01-24T09:00:00.000Z",
    //         jobTitle: "Mobile App Developer",
    //         postedon: "2026-01-10T07:00:00.000Z", // 19 days old
    //         companyName: "Appify",
    //         companyType: "Startup",
    //         status: 6,
    //         followSchedule: "No Schedule",
    //         jobLocation: "Remote",
    //         jobUrl: "https://appify.com/jobs/6",
    //         rate: "$42/hr",
    //         noOfApplicants: 18,
    //         assignedTo: 3,
    //     },
    // ];
    const rows = data.map((item) => ({
        uiid: item?.uiid,
        leadDate: item?.addedOn || "-",
        jobTitle: formatWords2(item?.jobTitle) || "-",
        postedDuration: item?.postedDuration || "-",
        companyId: item?.companyId?.uiid || null,
        companyName: formatWords2(item?.companyId?.name || "-"),
        companyType: AgreementType[item?.companyId?.oldInfo?.agreementType] || "N/A",
        status: item.status || 1,
        // followSchedule: item?.followupScheduled
        //     ? formatDateTime(item?.followupScheduled)
        //     : "No Schedule",
        followSchedule: item?.followupScheduled,
        jobLocation: `${item.location?.city || "N/A"}, ${item.location?.state || "N/A"}`,
        jobUrl: item?.jobUrl || "-",
        rate: item?.rate || "-",
        noOfApplicants: item?.noOfApplicants || "-",
        assignedTo: item?.assignedTo?.firstName
            ? {
                label: `${item?.assignedTo?.firstName || ""} ${item?.assignedTo?.lastName || ""}`,
                value: item?.assignedTo?.uiid,
            }
            : "",
    }));


    const mappedRows = mapTableRows(
        rows,
        columns
    );
    const buildSetPayload = (valueObj) => ([
        {
            type: "SET",
            value: valueObj,
        },
    ]);

    const handleUpdateLeadJob = async (uiid, payload) => {
        try {
            if (!uiid) return;

            const res = await updateLeadJob({
                coll: "LeadJob",
                uiid,
                payload: buildSetPayload(payload),
            });

            if(res?.data) {
                showToast("Updated successfully", "success");
            } else {
                showToast("Failed to update", "error");
            }
            // dispatch(
            //     fetchJobLeadsStart({
            //         coll: "LeadJob",
            //         lim: limit,
            //         pg: page,
            //         sort: { addedOn: -1 },
            //         extret: "uiid firstName lastName",
            //         ret: "uiid leadDate jobTitle companyId status followupScheduled location jobUrl rate noOfApplicants assignedTo addedBy addedOn postedDuration",
            //         ref: "Company",
            //         incl: ["uiid name oldInfo"],
            //     })
            // );
        } catch (error) {
            showToast("Failed to update", "error");
            console.error(error);
        }
    };

    const fetchBDMs = async () => {
        const count = await userRefCount({
            fil: JSON.stringify({
                "role.type": { type: "NONE", value: 3 },
            }),
        });
        const bdmCount = count?.data?.data || 0;
        try {
            const res = await fetchAllBDMUsers({
                fil: JSON.stringify({
                    "role.type": { type: "NONE", value: 3 },
                }),
                lim: bdmCount,
                ret: "uiid firstName lastName",
            });
            if (res?.data?.data) {
                const bdmList = res.data.data.map((r) => {
                    const first = r.firstName || "";
                    const last = r.lastName || "";
                    const fullName = `${first} ${last}`.trim();

                    return {
                        label: fullName,
                        value: r.uiid,
                    };
                });

                setAllBdms(bdmList);
            }
        } catch (error) {
            console.error("Failed to fetch BDMs", error);
        }
    };
    useEffect(() => {
        fetchBDMs();
    }, []);
    useEffect(() => {
        dispatch(
            totalCountStart({
                collection: "leadjobs",
                coll: "LeadJob",
                tname: "leadJobCount",
                app: "ats",
            })
        );
        dispatch(
            fetchJobLeadsStart({
                coll: "LeadJob",
                lim: limit,
                pg: page,
                sort: JSON.stringify({ addedOn: -1 }),
                extret: "uiid firstName lastName",
                ret: "uiid leadDate jobTitle companyId status followupScheduled location jobUrl rate noOfApplicants assignedTo addedBy addedOn postedDuration",
                ref: "Company",
                incl: ["uiid name oldInfo"]
            })
        );
    }, [dispatch, limit, page]);

  const handleRefresh = async () => {
    try {
      const res = await fetchAllLeadJobs({
        coll: "LeadJob",
        lim: limit,
        pg: page,
        sort: JSON.stringify({ addedOn: -1 }),
        extret: "uiid firstName lastName",
        ret: "uiid leadDate jobTitle companyId status followupScheduled location jobUrl rate noOfApplicants assignedTo addedBy addedOn postedDuration",
        ref: "Company",
        incl: ["uiid name oldInfo"],
      });
      console.log(res);
      if (res?.data?.data) {
        dispatch(fetchJobLeadsSuccess(res.data));
      } else {
        showToast("Failed to refresh leads", "error");
      }
    } catch (error) {
      showToast("Failed to refresh leads", "error");
      console.error(error);
    }
  };
    return (
        <div className="flex-1 flex overflow-auto">
            <TableAdv
                // showCheckbox
                columns={columns}
                rows={mappedRows}
                serverPagination={true}
                totalCount={totalCount}
                onSelectionChange={setSelectedRows}
                defaultSelectedRows={selectedRows}
                page={page}
                limit={limit}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                info={"info"}
                tdClassName="!py-3"
                toolbarRight={{
                    search: true,
                    filter: true,
                    add: [

                        {
                            component: (
                                <>
                                    <Button
                                        title="Download All"
                                        size="md"
                                    />
                                    <Button
                                        type="icon"
                                        color="black"
                                        icon="cached"
                                        variant="text"
                                        size="md"
                                        onClick={handleRefresh}
                                    />
                                </>
                            ),
                        },
                    ],
                }}
            />
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default Leads;
